import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { toast, type Id } from "react-toastify";
import type { AdPropertyUpdate } from "../../../zodios/apiDefinitions/api/ads";
import { roasToAcos } from "../../../components/core/blocks/AdPlan/utils";

export function useBulkUpdateAdProperties() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      vars: (Omit<AdPropertyUpdate, "custom_api_request"> & {
        target_roas?: number;
        min_roas?: number;
      })[],
    ) => {
      let toastId: Id | null = null;
      for (let i = 0; i < vars.length; i++) {
        const change = vars[i]!;
        if (change.target_roas !== undefined) {
          change.target_acos = roasToAcos(change.target_roas);
        }
        if (change.min_roas !== undefined) {
          change.max_acos = roasToAcos(change.min_roas);
        }
        const progress = (i + 1) / vars.length;
        try {
          await apiClient.updateAdProperties({
            custom_api_request: "update_advertisement",
            ...change,
          });
        } catch {
          toast(`Failed to update Media Plan ${change.id}`, { type: "error" });
        } finally {
          if (!toastId) {
            toastId = toast(`Updating Media Plan${vars.length > 1 ? "s" : ""}`, { progress, type: "info" });
          } else {
            toast.update(toastId, { progress });
          }
        }
      }
      if (toastId) {
        toast.update(toastId, {
          render: `Media Plan${vars.length > 1 ? "s" : ""} Updated`,
          type: "success",
          progress: undefined,
        });
      }
    },
    onSuccess: () => {
      // TODO: shouldn't invalidate _all_ queries
      void queryClient.invalidateQueries();
    },
  });
}
